// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPersonRegistrationVerifyRequestDto
 */
export interface IPersonRegistrationVerifyRequestDto {
    /**
     * 
     * @type {Date}
     * @memberof IPersonRegistrationVerifyRequestDto
     * @deprecated
     */
    birth_on?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPersonRegistrationVerifyRequestDto
     */
    local_date_birth_on?: Date;
    /**
     * 
     * @type {string}
     * @memberof IPersonRegistrationVerifyRequestDto
     */
    unique_id: string;
}

/**
 * Check if a given object implements the IPersonRegistrationVerifyRequestDto interface.
 */
export function instanceOfIPersonRegistrationVerifyRequestDto(value: object): value is IPersonRegistrationVerifyRequestDto {
    if (!('unique_id' in value) || value['unique_id'] === undefined) return false;
    return true;
}

export function IPersonRegistrationVerifyRequestDtoFromJSON(json: any): IPersonRegistrationVerifyRequestDto {
    return IPersonRegistrationVerifyRequestDtoFromJSONTyped(json, false);
}

export function IPersonRegistrationVerifyRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPersonRegistrationVerifyRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'birth_on': json['birth_on'] == null ? undefined : (new Date(json['birth_on'])),
        'local_date_birth_on': json['local_date_birth_on'] == null ? undefined : (new Date(json['local_date_birth_on'])),
        'unique_id': json['unique_id'],
    };
}

export function IPersonRegistrationVerifyRequestDtoToJSON(json: any): IPersonRegistrationVerifyRequestDto {
    return IPersonRegistrationVerifyRequestDtoToJSONTyped(json, false);
}

export function IPersonRegistrationVerifyRequestDtoToJSONTyped(value?: IPersonRegistrationVerifyRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'birth_on': value['birth_on'] == null ? undefined : ((value['birth_on']).toISOString()),
        'local_date_birth_on': value['local_date_birth_on'] == null ? undefined : ((value['local_date_birth_on']).toISOString().substring(0,10)),
        'unique_id': value['unique_id'],
    };
}

